import * as React from "react";
import { Grid } from "components/controls/widget";

const PageContainer = (props: any) => 
        <Grid container direction="column" wrap="nowrap" >
            {props.children}
        </Grid>;

export default PageContainer;